/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum EstadoPlanificacionEnum {
  Programada = 0,
  Seguimiento = 1,
  Finalizada = 2
}
